import React, { useEffect } from "react";
import { Box, Typography,Tooltip, } from "@mui/material";
import { formatDateIST } from "../common-functions/PaymentCommonFunctions";
import { FORM_PHASE, getFormStatusStyles, getFrontEndStatus } from "../../../../config/constant";
import alertCircle from "../../../../assets/icons/alert-circle.svg";
import { useTranslation } from "react-i18next";
import { checkIsMasked } from "../../../../utilis/common-funtions";

// Reusable header showing applicant summary and dates
const SummaryHeader = ({ applicantData, fromRelanding }) => {
  // Get dynamic colors for the status
  const statusStyles = getFormStatusStyles(applicantData?.voucherFormStatus);
  const { t } = useTranslation();
  
  const commonBoxStyles = {
    px: "12px",
    py: "6px",
    borderRadius: "8px",
    display: "flex",
    alignItems: { xs: "flex-start", sm: "center" },
    flexDirection: { xs: "column", sm: "row" },
    gap: "0.5rem",
  };

  // Left aligned
  const leftBoxStyles = {
    ...commonBoxStyles,
    justifyContent: "flex-start",
  };

  // Right aligned
  const rightBoxStyles = {
    ...commonBoxStyles,
    justifyContent: "flex-end",
  };
  // const isMasked = checkIsMasked(applicantData?.queueId);
  const isMaskedpaidVoucherId = checkIsMasked(applicantData?.paidVoucherId);
  const isMaskedstdEoiId = checkIsMasked(applicantData?.stdEoiId);
  const isMaskedpreEoiId = checkIsMasked(applicantData?.preEoiId);

  const entity = "Voucher";
  const stdEntity = "Standard EOI";
  const preEntity = "Preferential EOI";


  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexDirection: { xs: "column", sm: "row" },
        flexWrap: "wrap",
        gap: { xs: 2, sm: 0 },
      }}
    >
      {/* Left Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          flex: 1,
          width: { xs: "100%", sm: "auto" },
        }}
      >
        <Box sx={leftBoxStyles}>
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            Customer Name:
          </Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
            {`${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`}
          </Typography>
        </Box>

        <Box sx={leftBoxStyles}>
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            Mobile Number:
          </Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
            {applicantData?.applicant1?.personalDetails?.contactNumber}
          </Typography>
        </Box>
        { (
          <>
          <Box
            sx={{
              display: 'inline-block',
              backgroundColor: 'rgba(0, 184, 217, 0.08)',
              px: '12px',
              py: '6px',
              borderRadius: '8px',
              width: 'fit-content',
            }}
          >
            <Typography
              sx={{
                color: 'rgba(0, 108, 156, 1)',
                fontSize: '14px',
                fontWeight: 700,
              }}
            >  
            {t("voucherPreview.thankYou.uniqueReferenceId")}: {applicantData?.uniqueReferenceId ?? '-'}
            </Typography>
          </Box>
            {Boolean(applicantData?.paidVoucherId) && (
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <Box
                  sx={{
                    display: 'inline-block',
                    backgroundColor: 'rgba(0, 184, 217, 0.08)',
                    px: '12px',
                    py: '6px',
                    borderRadius: '8px',
                    width: 'fit-content',
                  }}
                >
                  <Typography
                    sx={{
                      color: 'rgba(0, 108, 156, 1)',
                      fontSize: '14px',
                      fontWeight: 700,
                    }}
                  >
                    {entity} ID: {applicantData?.paidVoucherId ?? '-'}
                  </Typography>
                </Box>
                {isMaskedpaidVoucherId && <Tooltip
                  arrow
                  enterTouchDelay={0}
                  placement="right"
                  title={t('voucherPreview.thankYou.maskedPaidToolTip', {
                    entity,
                  })}
                  sx={{ cursor: "pointer" }}
                >
                  <img src={alertCircle} alt="" style={{ cursor: "pointer" }} />
                </Tooltip>}
              </Box>)}</>
        )}
        {Boolean(applicantData?.stdEoiId) && (
          <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Box
              sx={{
                display: 'inline-block',
                backgroundColor: 'rgba(0, 184, 217, 0.08)',
                px: '12px',
                py: '6px',
                borderRadius: '8px',
                width: 'fit-content',
              }}
            >
              <Typography
                sx={{
                  color: 'rgba(0, 108, 156, 1)',
                  fontSize: '14px',
                  fontWeight: 700,
                }}
              >
                {t("voucherPreview.thankYou.standardEOIId")}: {applicantData?.stdEoiId ?? '-'}
              </Typography>
              
            </Box>
            {isMaskedstdEoiId && <Tooltip
              arrow
              enterTouchDelay={0}
              placement="right"
              title={t('voucherPreview.thankYou.maskedPaidToolTip', {
                entity: stdEntity,
              })}
              sx={{ cursor: "pointer" }}
            >
              <img src={alertCircle} alt="" style={{ cursor: "pointer" }} />
            </Tooltip>}
          </Box>
        )}
        {Boolean(applicantData?.preEoiId) && (
          <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Box
              sx={{
                display: 'inline-block',
                backgroundColor: 'rgba(0, 184, 217, 0.08)',
                px: '12px',
                py: '6px',
                borderRadius: '8px',
                width: 'fit-content',
              }}
            >
              <Typography
                sx={{
                  color: 'rgba(0, 108, 156, 1)',
                  fontSize: '14px',
                  fontWeight: 700,
                }}
              >
                {t("voucherPreview.thankYou.preferentialEOIId")}: {applicantData?.preEoiId ?? '-'}
              </Typography>
            </Box>
            {isMaskedpreEoiId && <Tooltip
                arrow
                enterTouchDelay={0}
                placement="right"
                title={t('voucherPreview.thankYou.maskedPaidToolTip', {
                  entity: preEntity,
                })}
                sx={{ cursor: "pointer" }}
              >
                <img src={alertCircle} alt="" style={{ cursor: "pointer" }} />
              </Tooltip>}
          </Box>  
        )}
           <Box
            sx={{
              display: "inline-block",
              backgroundColor: statusStyles.backgroundColor,
              px: "12px",
              py: "6px",
              borderRadius: "8px",
              width: "fit-content",
            }}
          >
            <Typography
              sx={{
                color: statusStyles.color,
                fontSize: "14px",
                fontWeight: 700,
              }}
            >
              Status: {getFrontEndStatus(applicantData?.voucherFormStatus) ?? "-"}
          </Typography>
        </Box>

        {/* Queue ID */}
        {/* <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <Box
            sx={{
              backgroundColor: "rgba(34, 197, 94, 0.08)",
              px: "12px",
              py: "6px",
              borderRadius: "8px",
              width: "fit-content",
              maxWidth: "100%",
            }}
          >
            <Typography
              sx={{
                color: "#118D57",
                fontSize: "14px",
                fontWeight: 700,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Queue ID: {applicantData?.queueId ?? "-"}
            </Typography>
          </Box>
          {isMasked && <Tooltip
            arrow
            enterTouchDelay={0}
            placement="right"
            title={t("voucherPreview.thankYou.maskedToolTip")}
            sx={{ cursor: "pointer" }}
          >
            <img src={alertCircle} alt="" style={{ cursor: "pointer" }} />
          </Tooltip>}
        </Box> */}

        <Box
          sx={{
            backgroundColor: "rgba(142, 51, 255, 0.08)",
            px: "12px",
            py: "6px",
            borderRadius: "8px",
            width: "fit-content",
            maxWidth: "100%",
          }}
        >
          <Typography
            sx={{
              color: "rgba(81, 25, 183, 1)",
              fontSize: "14px",
              fontWeight: 700,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            Preferred Typology:{" "}
            {(applicantData?.eoiDetails?.typology ||
              applicantData?.eoiDetails?.unitType) ??
              "-"}
          </Typography>
        </Box>
      </Box>

      {/* Right Section */}
      <Box
        sx={{
     
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          flex: 1,
          width: { xs: "100%", sm: "auto" },
        }}
      >
        <Box sx={rightBoxStyles}>
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            Initiated Date:
          </Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
            {applicantData?.createdAt
              ? formatDateIST(applicantData?.createdAt)
              : ""}
          </Typography>
        </Box>

     
        {((applicantData?.formPhase === FORM_PHASE.VOUCHER) || 
        (applicantData?.formPhase === FORM_PHASE.EOI && applicantData?.voucherIssuedAt)) && 
        <Box sx={rightBoxStyles}>
            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
              Voucher ID Issued:
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
              {formatDateIST(applicantData?.voucherIssuedAt)}
            </Typography>
          </Box>}
       

    
         {applicantData?.formPhase === FORM_PHASE.EOI && (
           <>
             {Boolean(applicantData?.stdEoiId) && (
               <Box sx={rightBoxStyles}>
                 <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                   Standard EOI ID Issued:
                 </Typography>
                 <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
                   {formatDateIST(applicantData?.stdEoiIssuedAt) ?? '-'}
                 </Typography>
               </Box>
             )}
             {Boolean(applicantData?.preEoiId) && (
               <Box sx={rightBoxStyles}>
                 <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                   Preferential EOI ID Issued:
                 </Typography>
                 <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
                   {formatDateIST(applicantData?.preEoiIssuedAt) ?? '-'}
                 </Typography>
               </Box>
             )}
           </>
         )}
      </Box>
    </Box>
  );
};

export default SummaryHeader;